import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/modules/common/modalReducer";

import "./RewardAlert.scss";
import closeImg from "styles/common/img/common/close7.png";

const RewardAlert = () => {
    const dispatch = useDispatch();
    const msg = useSelector((state) => state.modalReducer.msg);
    const subMsg = useSelector((state) => state.modalReducer.subMsg);
    const isConfirm = useSelector((state) => state.modalReducer.isConfirm);
    const onClickConfirm = useSelector((state) => state.modalReducer.onClickConfirm);

    const closeRewardAlert = () => {
        setTimeout(() => {
            dispatch(closeModal());
        }, 80);
    };

    const confirmRewardAlert = () => {
        closeRewardAlert();

        if (onClickConfirm) {
            onClickConfirm();
        }
    };

    const makeMsgLine = (msg, className) => {
        return msg.split("\n").map((line, index) => {
            return (
                <p key={index} className={className}>
                    {line}
                </p>
            );
        });
    };

    return (
        <div className="rewardModal">
            <button className="rewardModal__close" onClick={closeRewardAlert}>
                <img src={closeImg} alt="닫기" className="rewardModal__close-img" />
            </button>
            <div className="rewardModal-msg-main">{makeMsgLine(msg, "rewardModal-msg-main-line")}</div>
            {subMsg && <div className="rewardModal-msg-sub">{makeMsgLine(subMsg, "rewardModal-msg-sub-line")}</div>}
            {isConfirm ? (
                <div className="rewardModal-button">
                    <button className="rewardModal-button-item cancel-btn" onClick={closeRewardAlert}>
                        취소
                    </button>
                    <button className="rewardModal-button-item" onClick={confirmRewardAlert}>
                        확인
                    </button>
                </div>
            ) : (
                <div className="rewardModal-button">
                    <button className="rewardModal-button-item" onClick={confirmRewardAlert}>
                        확인
                    </button>
                </div>
            )}
        </div>
    );
};

export default RewardAlert;
